/**
 * Firebase Configuration
 * Environment-based configuration for Firebase Cloud Messaging
 */

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface PushNotificationConfig {
  firebase: FirebaseConfig;
  vapidKey: string;
  enabled: boolean;
}

/**
 * Get Firebase configuration based on environment
 * Reads from Vite environment variables
 */
export function getFirebaseConfig(): PushNotificationConfig {
  const isProd = import.meta.env.PROD;

  // Production configuration
  if (isProd && import.meta.env.VITE_FIREBASE_PROD_API_KEY) {
    return {
      firebase: {
        apiKey: import.meta.env.VITE_FIREBASE_PROD_API_KEY,
        authDomain: import.meta.env.VITE_FIREBASE_PROD_AUTH_DOMAIN,
        databaseURL: import.meta.env.VITE_FIREBASE_PROD_DATABASE_URL,
        projectId: import.meta.env.VITE_FIREBASE_PROD_PROJECT_ID,
        storageBucket: import.meta.env.VITE_FIREBASE_PROD_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_FIREBASE_PROD_MESSAGING_SENDER_ID,
        appId: import.meta.env.VITE_FIREBASE_PROD_APP_ID,
      },
      vapidKey: import.meta.env.VITE_FIREBASE_PROD_VAPID_KEY,
      enabled: import.meta.env.VITE_PUSH_NOTIFICATION_ENABLED !== 'false',
    };
  }

  // Staging/Development configuration (default)
  return {
    firebase: {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAl5F5OcszCmk7ozgirp7PMqDnMoiLN2Ss',
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'bluestonestaging.firebaseapp.com',
      databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || 'https://bluestonestaging.firebaseio.com',
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'bluestonestaging',
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'bluestonestaging.appspot.com',
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '628206761695',
      appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:628206761695:web:78996763e01398226d5b6a',
    },
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || 'BPrTpEwaFKjJXdVUdL9CSvOngUFAuAFeUkeCENL8IcyJLTvT3O8-Y0Lbs_NmisjzHO6h4cqyBqCSSk2nvdQDoM8',
    enabled: import.meta.env.VITE_PUSH_NOTIFICATION_ENABLED !== 'false',
  };
}
